import config from './config';

const deviceCanvas = document.getElementById(
  "device-canvas"
) as HTMLCanvasElement;
const deviceCanvasContext = deviceCanvas.getContext("2d");

export const staticDevice: HTMLImageElement = new Image();
export function showStaticDevice() {
  deviceCanvasContext.clearRect(0, 0, deviceCanvas.width, deviceCanvas.height);
  deviceCanvasContext.drawImage(
    staticDevice,
    0,
    0,
    deviceCanvas.width,
    deviceCanvas.height
  );
}
staticDevice.onload = showStaticDevice;
staticDevice.src = `https://storage.googleapis.com/karoo2-website/v012section165530_1.png`;

const canvasWidth = config.frameWidth;
const canvasHeight = config.frameHeight;

export function setSpriteOnCanvas(settings: {
  context: CanvasRenderingContext2D;
  targetFrameIndex: number;
  spriteSettings: {
    totalFrames: number;
    frameWidth: number;
    frameHeight: number;
    /** Number of rows in sprite */
    numRows: number;
    /** Number of columns in sprite */
    numCols: number;
    images: Array<HTMLImageElement>;
    paths: Array<string>;
  };
}) {
  const { context } = settings;
  const {
    totalFrames,
    frameWidth,
    frameHeight,
    numRows,
    numCols,
    images,
    paths,
  } = settings.spriteSettings;
  let { targetFrameIndex } = settings;

  // Calculated fields
  const maxFrameIndex = totalFrames - 1;
  if (targetFrameIndex > maxFrameIndex) {
    targetFrameIndex = maxFrameIndex;
  } else if (targetFrameIndex < 0){
    targetFrameIndex = 0;
  }
  const framesPerSprite = numRows * numCols;
  const spriteImgIndex = Math.floor(targetFrameIndex / framesPerSprite);
  const frameIndexInSprite = targetFrameIndex % framesPerSprite;
  const spriteImg: HTMLImageElement = images[spriteImgIndex];

  const rowIndex = Math.floor(frameIndexInSprite / numCols);
  const colIndex = frameIndexInSprite % numCols;
  // console.log(
  //   "sprite",
  //   // paths[spriteImgIndex],
  //   "targetFrameIndex",
  //   targetFrameIndex,
  //   "spriteImgIndex",
  //   spriteImgIndex,
  //   "row",
  //   rowIndex,
  //   "col",
  //   colIndex
  // );
  return context.drawImage(
    spriteImg,
    colIndex * frameWidth,
    rowIndex * frameHeight,
    frameWidth,
    frameHeight,
    0,
    0,
    canvasWidth,
    canvasHeight
  );
}

export function enableScroll() {
  gsap.set("#starting-spacer", { display: "none" });
  document.querySelector("body").classList.add("scroll-active");
}
export function disableScroll() {
  gsap.set("#starting-spacer", { display: "block" });
  document.querySelector("body").classList.add("scroll-active");
}